import React from 'react';
import { useSelector } from 'react-redux';

import Circle from './Circle';
import Polygon from './Polygon';

const Fence = () => {
  const fences = useSelector((state) => state.mission.json.fences);

  return (
    <>
      {fences.map((fence, index) => {
        if (fence.type === 'Circle') {
          return <Circle key={index} index={index} data={fence.data} />;
        } else if (fence.type === 'Polygon') {
          return <Polygon key={index} index={index} data={fence.data} />;
        }
        return null;
      })}
    </>
  );
};

export default Fence;
